import type { ReactNode } from "react";
import { LinkButton } from "../../Filters";

export function GridStatus({
  shown,
  total,
  onMore,
  noun,
  limitNote = " Narrow the filters to see the rest.",
}: {
  shown: number;
  total: number;
  onMore?: (() => void) | null | undefined;
  noun?: string;
  limitNote?: ReactNode;
}) {
  if (shown >= total) return null;
  return (
    <div className="flex items-center gap-2 border-b border-divider px-3 py-2 text-md text-muted">
      Showing the first {shown} of {total}
      {noun ? ` ${noun}` : ""}.{onMore ? <LinkButton onClick={onMore}>Show more</LinkButton> : limitNote}
    </div>
  );
}
